export default __webpack_public_path__ + "static/media/token.4efc20a5.png";